import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import makeStyles from '@mui/styles/makeStyles';
import {connect} from 'react-redux'
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import {useTranslation} from 'react-i18next';
import {deleteImage} from "../../../../../store/actions/store/ProductAction";
import {PRODUCT_GALLERY_IMAGE_VARIATION} from "../../../../../store/reducers/store/ProductReducer";
import Button from "../../../inputs/Button";

const useStyles = makeStyles(theme => ({
    imgToInsert: {
        textAlign: 'center'
    },
}));

const DeleteDialog = ({img, open, setOpen, deleting, deleteImage, productId}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        deleteImage(productId, img.Catalog_Product_Image__)
            .then(handleClose)
    };

    return (
        <Dialog
            open={open}
            aria-labelledby="Delete gallery picture"
            aria-describedby="Delete gallery picture"
            fullWidth
        >
            <DialogTitle id="gallery-delete-title">{t('confirm_delete_picture_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="gallery-delete-description">
                    {t('confirm_delete_picture_desc')}
                    <br/>
                    <Typography variant="body1" color="textPrimary" component="span">{t('are_you_sure')}</Typography>
                </DialogContentText>
                <Grid container justifyContent='center' alignItems='center' spacing={2}>
                    <Grid item xs={12} className={classes.imgToInsert}>
                        <img src={img.Drive_Item.Media_Image[PRODUCT_GALLERY_IMAGE_VARIATION]}
                             alt={img.Drive_Item.Filename}/>
                    </Grid>
                    <Grid item xs={12}>

                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color="primary" autoFocus onClick={handleClose} disabled={deleting}>
                    {t('back_btn')}
                </Button>
                <Button color="secondary" disabled={deleting} endIcon={<DeleteIcon/>} onClick={handleDelete}>
                    {t('delete_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        deleting: state.product.deletingImage
    }
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        deleteImage: (productId, imgId) => dispatch(deleteImage(productId, imgId, {image_variation: PRODUCT_GALLERY_IMAGE_VARIATION})),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);